import HistoricalMetrics from './HistoricalMetrics';

export default HistoricalMetrics;
